import React from 'react';

const PrivacyPolicy = () => {
  const styles = {
    pageBg: {
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      color: '#334155',
      lineHeight: '1.6',
    },
    container: {
      maxWidth: '850px',
      margin: '30px auto',
      background: '#ffffff',
      padding: '40px',
      borderRadius: '12px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    },
    header: {
      borderBottom: '2px solid #e2e8f0',
      paddingBottom: '20px',
      marginBottom: '30px',
    },
    h1: {
      color: '#0f172a',
      margin: '0 0 10px 0',
      fontSize: '26px',
    },
    subtitle: {
      color: '#64748b',
      fontSize: '14px',
    },
    h2: {
      color: '#2563eb',
      fontSize: '18px',
      marginTop: '30px',
      marginBottom: '15px',
      borderLeft: '4px solid #2563eb',
      paddingLeft: '10px',
    },
    paragraph: {
      marginBottom: '15px',
      fontSize: '15px',
    },
    list: {
      paddingLeft: '20px',
      marginBottom: '15px',
      fontSize: '15px',
    },
    listItem: {
      marginBottom: '8px',
    },
    highlightBox: {
      backgroundColor: '#eff6ff',
      border: '1px solid #bfdbfe',
      borderRadius: '8px',
      padding: '15px 20px',
      margin: '20px 0',
    },
    footer: {
      marginTop: '40px',
      paddingTop: '20px',
      borderTop: '1px solid #e2e8f0',
      fontSize: '13px',
      color: '#94a3b8',
      textAlign: 'center',
    },
  };

  return (
    <div style={styles.pageBg}>
      <div style={styles.container}>
        <header style={styles.header}>
          <h1 style={styles.h1}>Privacy Policy</h1>
          <div style={styles.subtitle}>
            Real-time Temperature &amp; Fleet Monitoring Application
          </div>
          <div style={styles.subtitle}>Last updated: August 24, 2026</div>
        </header>

        <section>
          <p style={styles.paragraph}>
            This Privacy Policy describes how our application collects, processes,
            and protects user and device data in connection with real-time
            temperature tracking and vehicle fleet management operations.
          </p>
        </section>

        <section>
          <h2 style={styles.h2}>1. Authentication &amp; Account Security</h2>
          <p style={styles.paragraph}>Access to the application is strictly controlled and secured:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Authentication:</strong> Users log in using a Username and Password.
            </li>
            <li style={styles.listItem}>
              <strong>Account Creation:</strong> Public registration is disabled.
              Accounts are strictly generated and assigned by system administrators through a secure administration portal.
            </li>
            <li style={styles.listItem}>
              <strong>Security:</strong> All login credentials and session tokens are transmitted over encrypted protocols (HTTPS / TLS) under Role-Based Access Control (RBAC).
            </li>
          </ul>
        </section>

        <section>
          <h2 style={styles.h2}>2. Data Handled by the Application</h2>
          <p style={styles.paragraph}>
            The application only processes professional operational data necessary
            for fleet and cold-chain management:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Real-time Temperature Monitoring:</strong> Continuous telemetry readings from temperature sensors and thermal probes installed in refrigerated vehicles.
            </li>
            <li style={styles.listItem}>
              <strong>Alerts &amp; Vehicle Statuses:</strong> Real-time detection and notifications for critical events, including temperature threshold breaches, offline trucks/vehicles, or grounded fleet units.
            </li>
            <li style={styles.listItem}>
              <strong>Device Push Identifiers (FCM Token):</strong> Unique device notification tokens required to deliver urgent push alarms and notifications.
            </li>
          </ul>
        </section>

        <section>
          <h2 style={styles.h2}>3. Background Alarms &amp; Push Notifications</h2>
          <div style={styles.highlightBox}>
            <strong>Urgent Alert System:</strong> To protect cold-chain integrity,
            the application uses Firebase Cloud Messaging (FCM) to deliver high-priority push notifications immediately, even when the application is closed or running in the background (e.g., offline trucks or temperature warnings).
          </div>
        </section>

        <section>
          <h2 style={styles.h2}>4. Data Sharing &amp; Disclosure</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              We do not sell, rent, or trade any personal or operational data to third parties.
            </li>
            <li style={styles.listItem}>
              Data is transmitted securely only to our dedicated cloud infrastructure and to Google Firebase services strictly for delivering instant push notifications.
            </li>
          </ul>
        </section>

        <section>
          <h2 style={styles.h2}>5. Contact &amp; Support</h2>
          <p style={styles.paragraph}>
            If you have any questions regarding user access or data processing,
            please contact your organization's system administrator or our technical support team:
          </p>
          <p style={styles.paragraph}>
            <strong>Support Email:</strong> virmaticsdevelopper@gmail.com
          </p>
        </section>

        <footer style={styles.footer}>
          &copy; 2026 Fleet &amp; Temperature Monitoring Platform. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;